export default "__VITE_ASSET__DDZ6kpVF__"